import * as React from 'react';
import {
  Datagrid,
  EditButton,
  List,
  SimpleList,
  TextField,
  TextInput,
  useTranslate,
  SelectInput,
} from 'react-admin';
import { Theme, useMediaQuery } from '@mui/material';
import booleanChoices from '../../../choices/common/boolean.choices';
import DeleteTagButton from '../../components/tags/DeleteTagButton';

const apiKeyFilters = [
  <TextInput
    source="q"
    label="ra.action.search"
    resettable
    alwaysOn
    sx={{ mb: 0.5 }}
  />,
  <SelectInput
    source="hasPosts"
    label="resource.tags.field.relatedPosts"
    choices={booleanChoices}
    alwaysOn
  />,
];

const TagsList = () => {
  const translate = useTranslate();
  const isSmall = useMediaQuery(
    (theme: Theme) => theme.breakpoints.down('sm'),
    { noSsr: true },
  );
  const isLarge = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'), {
    noSsr: true,
  });

  return (
    <List
      title={translate(`resource.tags.name`, {
        smart_count: 2,
      })}
      filters={apiKeyFilters}
      sort={{ field: 'postsCount', order: 'DESC' }}
    >
      {isSmall ? (
        <SimpleList
          primaryText={(record) => record.name}
          secondaryText={(record) => record.postsCount}
          tertiaryText={(record) =>
            new Date(record.updatedAt).toLocaleDateString()
          }
        />
      ) : (
        <Datagrid>
          <TextField source="name" label="resource.global.field.name" />
          <TextField
            source="postsCount"
            label={translate('resource.posts.name', {
              smart_count: 2,
            })}
          />
          <TextField
            source="articlesCount"
            label={translate('resource.articles.name', {
              smart_count: 2,
            })}
          />
          <TextField
            source="storiesCount"
            label={translate('resource.stories.name', {
              smart_count: 2,
            })}
          />
          <TextField
            source="galleriesCount"
            label={translate('resource.galleries.name', {
              smart_count: 2,
            })}
          />
          <TextField
            source="criticsCount"
            label={translate('resource.critics.name', {
              smart_count: 2,
            })}
          />
          <EditButton />
          {isLarge && <DeleteTagButton />}
        </Datagrid>
      )}
    </List>
  );
};

export default TagsList;
